import type OsanoConsentObject from '@alltrails/types/OsanoConsentObject';
import { setFacebookCookiesClientSide } from './facebook';
import { canSetMarketingCookiesForConsent } from './osanoConsent';
import { setRedditCookiesClientSide } from './reddit';

/**
 * Client-side counterpart to `setMarketingCookiesMiddleware`, run when Osano reports a consent
 * decision.
 *
 * @param osanoConsentObject - Consent as reported by the `osano-cm-initialized`/`-consent-saved` event.
 * @param apexDomain - Apex domain to scope the cookies to, so they are readable across subdomains.
 */
export function setMarketingCookiesClientSide(osanoConsentObject: OsanoConsentObject, apexDomain: string): void {
  if (!canSetMarketingCookiesForConsent(osanoConsentObject)) {
    return;
  }

  setFacebookCookiesClientSide(apexDomain);
  setRedditCookiesClientSide(apexDomain);
}
